export default "698bd60be0093d51.svg"